import React from "react";
import { Navigate, useLocation } from "react-router";

import { EPath } from "../constants/path";
import { useAuth } from "../contexts/AuthContext";
import { RouteConfig } from "./routeConfig";

interface ProtectedRouteProps {
  route: RouteConfig;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ route }) => {
  const { user, userClaims, loading } = useAuth();
  const location = useLocation();
  const Element = route.element;

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <div className="text-gray-600">Loading...</div>
        </div>
      </div>
    );
  }

  // If route is not protected, render directly
  if (!route.protected) {
    return <Element />;
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to={EPath.LOGIN} state={{ from: location }} replace />;
  }

  // Check if onboarding is required
  if (route.requireOnboarding && userClaims?.onboardingComplete === false) {
    // User is authenticated but needs to complete onboarding
    return <Element />;
  }

  // Note: Onboarding logic removed for slim starter
  // If you need onboarding, implement it here

  // User is authenticated and has completed onboarding (or onboarding is not required)
  return <Element />;
};

export default ProtectedRoute;
